/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IncidentInvestigationControllerDeleteMutationResponse, IncidentInvestigationControllerDeletePathParams } from "../../models/incidentAgentController/IncidentInvestigationControllerDelete";

function getIncidentInvestigationControllerDeleteUrl(id: IncidentInvestigationControllerDeletePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/incident-agent/investigations/${id}` as const }  
  return res
}

/**
 * {@link /api/v1/incident-agent/investigations/:id}
 */
export async function incidentInvestigationControllerDelete(id: IncidentInvestigationControllerDeletePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<IncidentInvestigationControllerDeleteMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "DELETE", url : getIncidentInvestigationControllerDeleteUrl(id).url.toString(), ... requestConfig })  
  return res.data
}